import { render, staticRenderFns } from "./student-round-view.vue?vue&type=template&id=aeafcefa&scoped=true"
import script from "./student-round-view.ts?vue&type=script&lang=ts&external"
export * from "./student-round-view.ts?vue&type=script&lang=ts&external"
import style0 from "./student-round-view.scss?vue&type=style&index=0&id=aeafcefa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeafcefa",
  null
  
)

export default component.exports